import AdminLayout from "@/components/admin/AdminLayout"
import { Button } from "@/components/ui/button"
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"

const recentOrders = [
    {
        orderNo: "20260311-0001",
        customer: "박정락",
        amount: "29,900원",
        status: "결제완료",
    },
    {
        orderNo: "20260311-0002",
        customer: "김하늘",
        amount: "54,000원",
        status: "배송준비중",
    },
    {
        orderNo: "20260311-0003",
        customer: "이수진",
        amount: "18,900원",
        status: "배송완료",
    },
]

const lowStockProducts = [
    { name: "프리미엄 멀티비타민 90정", stock: 4 },
    { name: "비건 핸드크림 세트", stock: 7 },
    { name: "저자극 클렌징 폼", stock: 2 },
]

export default function AdminDashboardPage() {
    return (
        <AdminLayout>
            <div className="space-y-6">
                <div>
                    <h2 className="text-3xl font-bold">대시보드</h2>
                    <p className="mt-2 text-sm text-slate-500">
                        쇼핑몰 운영 현황을 한눈에 확인할 수 있습니다.
                    </p>
                </div>

                {/* 💡 임시 테스트용 버튼 (화면 최상단에 배치) */}
                {/*<div style={{ padding: '20px', textAlign: 'center', backgroundColor: '#fee' }}>*/}
                {/*    <button*/}
                {/*      onClick={() => { throw new Error('Sentry 연동 테스트 에러입니다!'); }}*/}
                {/*      style={{ padding: '10px 20px', fontSize: '16px', background: 'red', color: 'white' }}*/}
                {/*    >*/}
                {/*        에러 발생시키기 💥*/}
                {/*    </button>*/}
                {/*</div>*/}

                <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
                    <Card className="rounded-[24px] border border-slate-200 shadow-sm">
                        <CardHeader>
                            <CardTitle className="text-base">오늘 주문</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <p className="text-3xl font-bold">128건</p>
                            <p className="mt-2 text-sm text-slate-500">전일 대비 +12%</p>
                        </CardContent>
                    </Card>

                    <Card className="rounded-[24px] border border-slate-200 shadow-sm">
                        <CardHeader>
                            <CardTitle className="text-base">오늘 매출</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <p className="text-3xl font-bold">3,420,000원</p>
                            <p className="mt-2 text-sm text-slate-500">전일 대비 +8%</p>
                        </CardContent>
                    </Card>

                    <Card className="rounded-[24px] border border-slate-200 shadow-sm">
                        <CardHeader>
                            <CardTitle className="text-base">신규 회원</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <p className="text-3xl font-bold">37명</p>
                            <p className="mt-2 text-sm text-slate-500">이번 주 누적 214명</p>
                        </CardContent>
                    </Card>

                    <Card className="rounded-[24px] border border-slate-200 shadow-sm">
                        <CardHeader>
                            <CardTitle className="text-base">미처리 문의</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <p className="text-3xl font-bold">9건</p>
                            <p className="mt-2 text-sm text-slate-500">빠른 확인이 필요합니다</p>
                        </CardContent>
                    </Card>
                </div>

                <div className="grid gap-6 xl:grid-cols-[1.2fr_0.8fr]">
                    <Card className="rounded-[28px] border border-slate-200 shadow-sm">
                        <CardHeader className="flex flex-row items-center justify-between">
                            <CardTitle className="text-xl">최근 주문</CardTitle>
                            <Button variant="outline" className="rounded-xl">
                                전체 주문 보기
                            </Button>
                        </CardHeader>

                        <CardContent>
                            <div className="overflow-x-auto">
                                <table className="w-full min-w-[600px] text-sm">
                                    <thead>
                                    <tr className="border-b border-slate-200 text-left text-slate-500">
                                        <th className="px-2 py-3 font-medium">주문번호</th>
                                        <th className="px-2 py-3 font-medium">고객명</th>
                                        <th className="px-2 py-3 font-medium">결제금액</th>
                                        <th className="px-2 py-3 font-medium">상태</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {recentOrders.map((order) => (
                                        <tr key={order.orderNo} className="border-b border-slate-100">
                                            <td className="px-2 py-4 font-medium text-slate-900">
                                                {order.orderNo}
                                            </td>
                                            <td className="px-2 py-4">{order.customer}</td>
                                            <td className="px-2 py-4">{order.amount}</td>
                                            <td className="px-2 py-4">
                          <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-700">
                            {order.status}
                          </span>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </CardContent>
                    </Card>

                    <div className="space-y-6">
                        <Card className="rounded-[28px] border border-slate-200 shadow-sm">
                            <CardHeader>
                                <CardTitle className="text-xl">재고 부족 상품</CardTitle>
                            </CardHeader>
                            <CardContent className="space-y-3">
                                {lowStockProducts.map((product) => (
                                    <div
                                        key={product.name}
                                        className="flex items-center justify-between rounded-2xl bg-slate-50 p-4"
                                    >
                                        <div>
                                            <p className="font-medium text-slate-900">{product.name}</p>
                                            <p className="mt-1 text-sm text-slate-500">
                                                빠른 발주 확인 필요
                                            </p>
                                        </div>
                                        <span className="rounded-full bg-rose-100 px-3 py-1 text-sm font-semibold text-rose-600">
                      {product.stock}개
                    </span>
                                    </div>
                                ))}
                            </CardContent>
                        </Card>

                        <Card className="rounded-[28px] border border-slate-200 shadow-sm">
                            <CardHeader>
                                <CardTitle className="text-xl">운영 바로가기</CardTitle>
                            </CardHeader>
                            <CardContent className="grid gap-3">
                                <Button className="justify-start rounded-xl bg-slate-900 hover:bg-slate-800">
                                    신규 상품 등록
                                </Button>
                                <Button variant="outline" className="justify-start rounded-xl">
                                    주문 상태 일괄 변경
                                </Button>
                                <Button variant="outline" className="justify-start rounded-xl">
                                    메인 배너 수정
                                </Button>
                                <Button variant="outline" className="justify-start rounded-xl">
                                    쿠폰 발급 관리
                                </Button>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </div>
        </AdminLayout>
    )
}